import api from "./apiClient";

const registerNewDoc = (data: any) => {
    return api.post('/createUser', JSON.stringify(data));
}


export {
    registerNewDoc,
}

